<template>
	<div class="container">
		<div class="main_box">
			<!--块1-->
			<div class="block_1">
				<div class="block_1_main">
					<div class="tit_box"
						data-aos="fade-up"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
					>
						<div class="tit">Leave a message</div>
						<div class="txt">Leave your contact information and suggestions for us to provide feedback and product improvement.</div>
					</div>
					<div class="form_box"
						data-aos="fade-in"
						data-aos-duration="400"
						data-aos-delay="200"
						data-aos-offset="0"
						data-aos-once="true"
					>
						<div class="input_box">
							<div class="tit">Name：</div>
							<div class="input_el">
								<input v-model="username" />
							</div>
							<div class="tips">*</div>
						</div>
						<div class="input_box">
							<div class="tit">Telephone：</div>
							<div class="input_el">
								<input v-model="phone" />
							</div>
							<div class="tips">*</div>
						</div>
						<div class="input_box">
							<div class="tit">Email：</div>
							<div class="input_el">
								<input v-model="email" />
							</div>
							<div class="tips">*</div>
						</div>
						<div class="textarea_box">
							<div class="tit">Content：</div>
							<div class="textarea_el">
								<textarea v-model="content"></textarea>
							</div>
						</div>
						<div class="btn_box" @click="submit">Submit</div>
					</div>
					<div class="msg_box"
						data-aos="fade-up"
						data-aos-duration="400"
						data-aos-delay="200"
						data-aos-offset="0"
						data-aos-once="true"
					>
						<div class="msg_el" style="font-size: 16px;">
							<van-icon name="phone-o" size="18px" style="top: 4px;" />&nbsp;
							<a href="tel:+86-10-69390616">+86-10-69390616</a>&ensp;|&ensp;<a href="tel:+86-10-69390660">+86-10-69390660</a>
						</div>
						<div class="msg_el" style="margin-bottom: 16px;font-size: 16px;">
							<van-icon name="envelop-o" size="18px" style="top: 4px;" />&nbsp;
							<a href="mailto:info@coretests.com">info@coretests.com</a>
						</div>
						<div class="msg_el">
							{{ $t('footer.text1') }}<span style="font-size: 16px;">3333 Piedmont Rd NE #700, Atlanta GA, 30305</span>
						</div>
						<div class="msg_el">
							{{ $t('footer.text2') }}
						</div>
						<div class="msg_el">
							{{ $t('footer.text3') }}
						</div>
					</div>
				</div>
			</div>
			<!--块1-->
		</div>
	</div>
</template>

<script>
import { submitMsg } from '@/api/public'  //提交留言
import md5 from 'js-md5';
export default {
	components:{
		//
	},
	data() {
		return {
			username: '',
			phone: '',
			email: '',
			content: ''
		}
	},
	created(){
		let that = this;
	},
	mounted() {
		let that = this;
	},
	watch: {
		//
	},
	methods: {
		//点击提交
		submit() {
			let that = this;
			if(that.username && that.phone && that.email) {
				that.$toast.loading({ message: '', forbidClick: true, duration: 0 });
				submitMsg({
					name: that.username,
					mobile: that.phone,
					email: that.email,
					content: that.content,
					language: sessionStorage.getItem('lang'),
					access_token: md5(String(that.username)+String(that.email)+String(that.phone)+'CoretestsByAiiso')
				}).then(res => {
					that.$toast.clear();
					that.username = '';
					that.phone = '';
					that.email = '';
					that.content = '';
					that.$toast('Submitted successfully');
				});
			}else {
				that.$toast('Please complete the information first');
			}
		},
	}
}
</script>

<style lang="less" scoped>
.main_box{
	//块1
	.block_1{
		background: url(../../../assets/img_public/about/contact/h5_banner01.webp) no-repeat 100% 100%;
		background-size: cover;
		.block_1_main{
			padding: 40px 20px;
			.msg_box{
				.msg_el{
					margin-bottom: 5px;
					a{
						color: #000000;
					}
				}
			}
			.form_box{
				padding-top: 40px;
				.btn_box{
					width: 180px;
					height: 48px;
					margin: 40px auto 50px auto;
					line-height: 48px;
					font-size: 18px;
					text-align: center;
					color: #ffffff;
					background: linear-gradient( 90deg, #CF0272 0%, #A20073 100%);
					border-radius: 8px 8px 8px 8px;
					cursor: pointer;
				}
				.textarea_box{
					display: flex;
					height: 160px;
					margin: 0;;
					padding: 14px 24px;
					background-color: #ffffff;
					border-radius: 12px;
					.textarea_el{
						flex: 1;
						textarea{
							width: 100%;
							height: 100%;
							border: none;
							font-size: 18px;
							resize: none;
						}
					}
					.tit{
						width: auto;
						font-size: 16px;
					}
				}
				.input_box{
					display: flex;
					align-items: center;
					height: 58px;
					margin-bottom: 20px;
					padding: 0 24px;
					background-color: #ffffff;
					border-radius: 12px;
					.input_el{
						flex: 1;
						input{
							width: 100%;
							height: 58px;
							padding: 0 12px 0 4px;
							font-size: 18px;
							border: none;
						}
					}
					.tips{
						width: auto;
						position: relative;
						top: 5px;
						font-size: 20px;
						color: #A20073;
					}
					.tit{
						width: auto;
						font-size: 16px;
					}
				}
			}
			.tit_box{
				text-align: center;
				.txt{
					padding-top: 4px;
					font-size: 14px;
				}
				.tit{
					font-size: 30px;
				}
			}
		}
	}
}
</style>